import { Building2 } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';

export const AuthShell = ({ title, description, children, testId }) => (
  <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50" data-testid={testId}>
    <Card className="w-full max-w-md border-slate-200 shadow-sm">
      <CardHeader className="space-y-1 pb-6">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-10 h-10 rounded-lg bg-orange-500 flex items-center justify-center">
            <Building2 className="h-5 w-5 text-white" />
          </div>
          <span className="font-bold text-lg">AVM Belge Takip</span>
        </div>
        <CardTitle className="text-2xl font-bold">{title}</CardTitle>
        {description && <CardDescription>{description}</CardDescription>}
      </CardHeader>
      <CardContent>{children}</CardContent>
    </Card>
  </div>
);

export const apiError = (err, fallback) => {
  const d = err.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map(e => (e?.msg || '').replace(/^Value error, /, '')).join(' ');
  return fallback;
};
